import React, { useState } from "react";
import FirmwareDataTable from "./FirmwareDataTable";
import * as url from "../../../helpers/url_helper";
import { Images } from "../../../constants/images";
import { convertLocalDate } from "../../../Utils/configController";
import { ToastContainer, toast } from "react-toastify";

const FirmwareVersionList = ({ setDataTableId }: any) => {
  // const [dataTableId, setDataTableId] = useState(null);
  const columns = [
    {
      title: "Hardware",
      render: function (data: any, type: any, row: any) {
        return row?.name ? `${row?.name}(${row?.hardwareVersion})` : "-";
      },
    },
    {
      title: "Firmware Version",
      render: function (data: any, type: any, row: any) {
        return row?.firmwareVersion ? `${row?.firmwareVersion}` : "-";
      },
    },
    {
      title: "Type",
      render: function (data: any, type: any, row: any) {
        const typeBadge =
          row?.env === "qa"
            ? '<span class="font-size-11 badge-soft-danger badge bg-secondary">QA</span>'
            : '<span class="font-size-11  badge-soft-success badge bg-secondary">PROD</span>';
 
        return typeBadge;
      },
    },
    {
      title: "Is Stable?",
      render: function (data: any, type: any, row: any) {
        return row?.isStable ? "1" : "0";
      },
    },
    {
      title: "Uploaded Date",
      render: function (data: any, type: any, row: any) {
        return row?.createdAt ? convertLocalDate(row?.createdAt) : "-";
      },
    },
    {
      title: "Download",
      render: function () {
        return `<div class="d-flex gap-2">
                                <button class="edit-btn" style="border: none; outline: none; background: none;">
                                <img src="${Images.DownloadIcon}" alt="Download" style="width: 20px; height: 20px;">
                                </button>
                                 <button class="copy-link" style="border: none; outline: none; background: none;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                                    </svg>
                                </button>
                                

                            </div>`;
      },
    },
  ];
  const handleDownloadClick = (rowData: any) => {
    const url = rowData.binFilePath.includes("http:")
      ? rowData.binFilePath.replace("http:", "https:")
      : rowData.binFilePath;

    const link = document.createElement("a");
    link.href = url;
    link.download = "filename.bin"; // Set the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleCopyLinkClick = (rowData: any) => {
    const url = rowData.binFilePath.includes("http:")
      ? rowData.binFilePath.replace("http:", "https:")
      : rowData.binFilePath;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Copied!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);

        toast.success("Failed to copy");
      });
  };
  const handleDataTableIdChange = (dataTableId: any) => {
    // Now you have access to the DataTable ID here
    setDataTableId(dataTableId);
    // You can do whatever you need with the ID in this component
  };

  return (
    <>
      <ToastContainer />
      <FirmwareDataTable
        // data={areaList}
        apiURL={`${url.BASE_URL}${url.FIRMWARE_LIST}`}
        columns={columns}
        title={"Firmware Version List"}
        handleEditClick={handleDownloadClick}
        handleCopyLinkClick={handleCopyLinkClick}
        onDataTableRefresh={handleDataTableIdChange}
        idName={"FirmwareVesrionList"}
      />
    </>
  );
};

export default FirmwareVersionList;
